import { ComponentType } from '@angular/cdk/portal';
import { Injectable, NgZone } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent, ConfirmDialogOptions } from './confirm-dialog/confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(
    private _dialog: MatDialog,
    private _ngZone: NgZone
  ) { }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  open<T, D = any, R = any>(component: ComponentType<T>, config?: MatDialogConfig<D>): Promise<MatDialogRef<T, R>> {
    return new Promise<MatDialogRef<T, R>>((resolve, reject) => {
      //Forcing the dialog to be opened in angular zone is required for the dialog to be rendered correctly
      this._ngZone.run(() => {
        try {
          const dialogRef = this._dialog.open(component, config);
          resolve(dialogRef)
        } catch (error) {
          reject(error)
        }
      })
    })
  }

  openConfirmDialog(options: ConfirmDialogOptions): Promise<MatDialogRef<ConfirmDialogComponent, boolean>> {
    return new Promise<MatDialogRef<ConfirmDialogComponent, boolean>>((resolve, reject) => {
      //Forcing the dialog to be opened in angular zone is required for the dialog to be rendered correctly
      this._ngZone.run(() => {
        try {
          const dialogRef = this._dialog.open(ConfirmDialogComponent, {
            width: '500px',
            data: options
          });
          resolve(dialogRef)
        } catch (error) {
          reject(error)
        }
      })
    })
  }
}
